/** @internal */
export function defaultFormatterFunction(username, toYear, toMonth, toDay) {
    var url = "https://gh-contrib-parser-public.herokuapp.com/fetch" /* DEFAULT_PUBLIC_HOST */ + "/" + username;
    if (toYear && toMonth && toDay) {
        url += "?to=" + toYear + "-" + toMonth + "-" + toDay;
    }
    return url;
}



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/CalendarFetcher/defaultFormatterFunction.ts
// module id = 13
// module chunks = 0 1